/** @format */

import { defineStore, StoreDefinition } from 'pinia';
import { store } from '@/store';
import { generatorDynamicRouter } from '@/router/generator-router';

interface RouterState {
	vueModules: any;
	constantRouterComponents: any;
	router: any;
	route: any;
	routes: any;
	common: any;
	endRoutes: any;
	whiteNameList: any;
	linkUrl?: string;
}

export const useRouterStore: StoreDefinition = defineStore({
	id: 'p-components-router',
	state: (): RouterState => ({
		vueModules: [],
		constantRouterComponents: {},
		router: null,
		route: null,
		routes: [],
		common: [],
		endRoutes: [],
		whiteNameList: [],
		linkUrl: '',
	}),
	getters: {
		mConstantRouterComponents(): any {
			return this.constantRouterComponents;
		},
	},
	actions: {
		setLinkUrl(url) {
			this.linkUrl = url;
		},
		setConstantRouterComponents(constantRouterComponents) {
			this.constantRouterComponents = constantRouterComponents;
		},
		setVueModules(vueModules) {
			this.vueModules = vueModules;
		},
		setRouter(router) {
			this.router = router;
		},
		setRoute(route) {
			this.route = route;
		},
		setRoutes(routes) {
			this.routes = routes;
		},
		setCommonRoutes(common) {
			this.common = common;
		},
		setEndRoutes(endRoutes) {
			this.endRoutes = endRoutes;
		},
		setWhiteNameList(whiteNameList) {
			this.whiteNameList = whiteNameList;
		},
		generatorDynamicRouter(menus) {
			// 生成路由
			const generatorResult = generatorDynamicRouter(menus);
			console.log('generatorResult', generatorResult);
			return generatorResult;
		},
		// setRoutes(routes) {
		// 	this.router.addRoute(routes);
		// },

		/** 初始化基础数据 */
		async initData() {},
	},
});

// 在组件setup函数外使用
export function useRouterStoreWithOut(): any {
	return useRouterStore(store);
}
